import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { httpsCallable } from 'firebase/functions';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { FirebaseFirestoreService } from '../../services/firebase-firestore.service';
import { Observable, filter, first, firstValueFrom, tap } from 'rxjs';
import { FormBuilder, FormsModule } from '@angular/forms';
import { DocumentData } from '@angular/fire/firestore';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinner, ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogService } from 'primeng/dynamicdialog';
import { NameDialogComponent } from '../new-folder-dialog/name-dialog.component';
import { FirebaseFunctionService } from '../../services/firebase-function.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface Profile {
  id: string
  name: string
  email: string
  addedTime: Date
}

@Component({
  selector: 'app-enterprise-admin-view',
  standalone: true,
  imports: [
    CardModule,
    InputTextModule,
    DatePipe,
    ButtonModule,
    ProgressSpinnerModule,
    FormsModule,
    ToastModule
  ],
  templateUrl: './enterprise-admin-view.component.html',
  styleUrl: './enterprise-admin-view.component.scss',
  providers:[DialogService]
})
export class EnterpriseAdminViewComponent {
  firestoreService = inject(FirebaseFirestoreService)
  fb = inject(FormBuilder)
  dialogService = inject(DialogService)
  firebaseFunctions = inject(FirebaseFunctionService)
  messageSerivce = inject(MessageService)
  destroyRef = inject(DestroyRef)

  userData$: Observable<DocumentData | undefined>
  seats: (Profile | null)[]
  groupOwner: string
  groupName: string

  constructor() {
    this.initalizeData()
  }

  initalizeData() {
    this.firestoreService.getGroupData().then(dataPipe => {
      dataPipe.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(groupData => {
        if (!groupData) {
          return
        }
        const seatCatch = []
        for (let i = 0; i < groupData['seats']; i++) {
          const currentProfile = groupData['profiles'][i]
          if (currentProfile) {
            seatCatch.push({
              ...currentProfile,
              addedTime: new Date(currentProfile.addedTime)
            })
          }
          else {
            seatCatch.push(null)
          }
        }
        this.seats = seatCatch
        this.groupName = groupData['groupName']
        this.groupOwner = groupData['ownerId']
      })
    })
  }

  assignSeat() {
    this.dialogService.open(NameDialogComponent, {
      header: `Assign Seat to User`,
      width: '450px',
      data: {
        textInput: "User Email",
        completedText: "Add",
        completedIcon: "pi fi fi-rr-user-add"
      }
    }).onClose.pipe(
      filter(x => !!x),
      first()
    ).subscribe(async (userToAdd: string) => {
          httpsCallable(this.firebaseFunctions.functions, "addUserToGroup")({
            userToAdd
          })
          .catch((error) => {
            this.messageSerivce.add({severity: 'error', summary: error.code, detail: error.message.replace("FirebaseError: ", "")});
          })

    })
  }

  removeUserFromSeat(userToRemove: string) {
    httpsCallable(this.firebaseFunctions.functions, "removeUserFromGroup")({
      userToRemove
    })
    .catch((error) => {
      this.messageSerivce.add({severity: 'error', summary: error.code, detail: error.message.replace("FirebaseError: ", "")});
    })
  }
}
